<template>
  <d-container fluid>
    <d-row>
      <main class="main-content col-lg-12 col-md-12 col-sm-12 p-0">
        <slot />
      </main>
    </d-row>
  </d-container>
</template>

<script>

export default {
};
</script>
